import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { createOpeningApplicant } from "./api";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { employee, ...rest } = values;

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        )
    };

    if (employee !== undefined) {
        payload.employee = employee?.id;
    }

    return payload;
}

export function useCreateOpeningApplicant() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);

            try {
                const response = await createOpeningApplicant({ item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Applicant added successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
